/**
 * Created by yuxin Wei on 2017/10/19.
 */
/* 封装sessionStorage、localStorage*/
export default {
  //localStorage教材信息
  getlocalStorage: function (key, value, currentData) {
    let params = localStorage.getItem(value);
    if (params) {
      let obj = JSON.parse(params);
      for (let i = 0, len = currentData.length; i < len; i++) {
        if (currentData[i].code === obj.code) {
          //当前存在
          return obj;
        }
      }
      return currentData[0];
    } else {
      return currentData[0];
    }
  },
  getParamFromSessionStorage: function (key, value) {
    const paramsTemp = sessionStorage.getItem('selfStudyState');
    if (paramsTemp) {
      const objTemp = JSON.parse(paramsTemp);
      return objTemp[key];
    }
    return value;
  },

  //公共session
  getSessionStorage: function (key, value) {
    const keyValue = sessionStorage.getItem(key);
    if (keyValue) {
      return keyValue;
    }
    return value;
  },

  getSessionStorageExtend: function (key, defaultValue, isObject) {
    let keyResult = this.getSessionStorage(key, defaultValue);
    if (isObject) {
      return JSON.parse(keyResult);
    } else {
      return keyResult;
    }
  },
  setSessionStorage: function (key, value) {
    sessionStorage.setItem(key, value);
  },
  removeSessionStorage: function (key) {
    sessionStorage.removeItem(key);
  },
  removeAllSessionStorage:function(){
    sessionStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/common/storage.js